import { createRoot } from 'react-dom/client';
import { type MenuItemDef } from 'ag-grid-community';
import { ForgeIcon } from '@tylertech/forge-react';

import { I18n } from 'common/i18n';

/**
 * Builds the "Pin column" / "Unpin column" item for a table column's kebab menu.
 */
export const getPinColumnMenuItem = ({
  columnName,
  isPinned,
  handleColumnPinnedChange,
}: {
  columnName: string;
  isPinned: boolean;
  handleColumnPinnedChange: (columnName: string, pinned: boolean) => void;
}): MenuItemDef => {
  return {
    name: isPinned
      ? I18n.t('common.ag_grid_react.unpinColumnMenuItem')
      : I18n.t('common.ag_grid_react.pinColumnMenuItem'),
    action: () => {
      handleColumnPinnedChange(columnName, !isPinned);
    },
    icon: (() => {
      const container = document.createElement('div');
      const root = createRoot(container);
      root.render(<ForgeIcon external name={isPinned ? 'pin_off' : 'pin'} />);
      return container;
    })(),
  };
};
